(() => {
  'use strict';
  document.querySelectorAll('[data-med-offer]').forEach(offer => {
    const buttons = [...offer.querySelectorAll('[data-med-buy]')];
    const button = buttons[0];
    if (!button) return;
    const sticky = offer.querySelector('[data-med-sticky]');
    if (sticky && window.IntersectionObserver) {
      const inlineButtons = buttons.filter(b => !b.closest('[data-med-sticky]'));
      const inlineVisibility = new Map(inlineButtons.map(b => [b, true]));
      let offerVisible = true;
      const syncSticky = () => { sticky.hidden = [...inlineVisibility.values()].some(Boolean) || !offerVisible || uncertain || completed; };
      const inlineObserver = new window.IntersectionObserver(entries => {
        entries.forEach(entry => inlineVisibility.set(entry.target, entry.isIntersecting));
        syncSticky();
      });
      inlineButtons.forEach(b => inlineObserver.observe(b));
      new window.IntersectionObserver(entries => {
        offerVisible = entries[0].isIntersecting;
        syncSticky();
      }).observe(offer);
    }
    const error = offer.querySelector('[data-med-error]');
    const review = offer.querySelector('[data-med-review]');
    const variant = Number(offer.dataset.variant);
    const gift = Number(offer.dataset.gift);
    const campaign = offer.dataset.campaign || 'mediterranean-199-20261005';
    const expectedPrice = campaign === 'mediterranean-199-20261005' ? 19900 : campaign === 'halloween-weeknight-219-20261005' ? 21900 : 0;
    const valid = expectedPrice > 0 && [variant,gift].every(id => Number.isSafeInteger(id) && id > 0) && Number(offer.dataset.price) === expectedPrice;
    let busy = false, uncertain = false, completed = false;
    const read = async () => {
      const response = await window.fetch(offer.dataset.root + 'cart.js', {credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error('cart_unavailable');
      const cart = await response.json();
      if (cart.currency !== offer.dataset.currency || !Array.isArray(cart.items) || !Number.isSafeInteger(cart.item_count) ||
          cart.items.some(item => !item || !Number.isSafeInteger(item.quantity) || item.quantity < 1 || !item.key) ||
          cart.items.reduce((sum,item) => sum+item.quantity,0) !== cart.item_count) throw new Error('cart_unreadable');
      return cart;
    };
    const inventory = items => {
      const quantities = new Map();
      for (const item of items) {
        const identity = JSON.stringify([Number(item.variant_id), item.original_price, item.selling_plan_allocation?.selling_plan?.id || null, Object.entries(item.properties || {}).sort(([a],[b]) => a.localeCompare(b))]);
        quantities.set(identity, (quantities.get(identity) || 0) + item.quantity);
      }
      return JSON.stringify([...quantities].sort(([a],[b]) => a.localeCompare(b)));
    };
    const verified = (cart,before,marker,addGift) => {
      const added = cart.items.filter(item => item.properties?._med_selection === marker);
      const chicken = added.filter(item => Number(item.variant_id) === variant);
      const freeGifts = cart.items.filter(item => Number(item.variant_id) === gift && item.gift_card === true && item.quantity === 1 && item.original_price === 5000 && item.final_line_price === 0 && !item.selling_plan_allocation);
      return added.length === (addGift ? 2 : 1) && chicken.length === 1 && chicken[0].quantity === 1 && chicken[0].original_price === expectedPrice && chicken[0].final_price === expectedPrice && !chicken[0].selling_plan_allocation && freeGifts.length === 1 &&
        (!addGift || freeGifts[0].properties?._med_selection === marker) &&
        // Shopify recalculates line keys when bundle discounts change. Compare
        // the complete saved merchandise instead, including plan and properties.
        inventory(cart.items.filter(item => item.properties?._med_selection !== marker)) === inventory(before.items);
    };
    const finish = async (cart,before,marker,addGift) => {
      if (!verified(cart,before,marker,addGift)) return false;
      if (!window.tnmCaseShipping || !window.tnmHalloweenGiftGuard) throw new Error('checkout_unavailable');
      await window.tnmCaseShipping.ensure(cart);
      const safety = await window.tnmHalloweenGiftGuard.ensureSafe();
      if (!safety.safe) throw new Error('checkout_review_required');
      if (!verified(safety.cart,before,marker,addGift)) throw new Error('cart_changed');
      if (campaign === 'halloween-weeknight-219-20261005') {
        if (!window.tnmFreeMeatGift) throw new Error('checkout_unavailable');
        const freeMeat = await window.tnmFreeMeatGift.ensure();
        if (!freeMeat.safe) throw new Error('checkout_review_required');
      }
      completed = true;
      window.location.assign(offer.dataset.root + (campaign === 'halloween-weeknight-219-20261005' ? 'checkout' : 'pages/bundle-builder'));
      return true;
    };
    const setButtonState = (disabled, isBusy) => buttons.forEach(b => {
      b.disabled = disabled;
      if (isBusy) b.setAttribute('aria-busy','true'); else b.removeAttribute('aria-busy');
    });
    const purchase = async () => {
      if (busy || uncertain || completed || !valid) return;
      busy = true; setButtonState(true, true); error.hidden = true; review.hidden = true;
      let before, marker, addGift, sent = false;
      try {
        before = await read(); marker = crypto.randomUUID();
        addGift = !before.items.some(item => Number(item.variant_id) === gift && item.gift_card === true && item.quantity === 1 && item.final_line_price === 0);
        const properties = {_tnm_campaign:campaign,_med_selection:marker};
        const items = [{id:variant,quantity:1,properties}];
        if (addGift) items.push({id:gift,quantity:1,properties});
        sent = true;
        await window.fetch(offer.dataset.root + 'cart/add.js', {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
        if (await finish(await read(),before,marker,addGift)) return;
        throw new Error('cart_unverified');
      } catch {
        uncertain = sent;
        if (sent && before && marker) {
          try { if (await finish(await read(),before,marker,addGift)) return; } catch { /* Keep the cart available for review. */ }
        }
        error.textContent = sent ? 'Please review your cart before continuing. We could not verify the complete case, free gift, and shipping offer.' : 'We could not read your cart. Please try again.';
        error.hidden = false; review.hidden = !sent; error.focus();
      } finally { busy = false; setButtonState(uncertain || completed, false); if (sticky && (uncertain || completed)) sticky.hidden = true; }
    };
    buttons.forEach(b => b.addEventListener('click', purchase));
  });
})();
